export const REACT_APP_INVENTORY_ROUTING_URL = process.env.REACT_APP_INVENTORY_ROUTING_URL || "/inventory";
